import { STATUS_CERTIFIED } from './../../constants/roleRequirementStatus';
import type { IRoleRequirement } from './../../stores/JobApplicationStore/RoleRequirement';
export const transformRoleRequirementsIntoCertifications = (
  roleRequirements: IRoleRequirement[],
) =>
  roleRequirements
    .map((rr) => ({
      question_id: rr.questionId,
      question_global_id: rr.globalId,
      is_certified: rr.status === STATUS_CERTIFIED, // deprecated in data platform
      answers: rr.rrAnswers
        .filter((rrAnswer) => rrAnswer.isVerified)
        .map((rrAnswer) => ({
          answer_id: rrAnswer.id ?? '',
          answer_global_id: rrAnswer.globalId,
          is_certified: rrAnswer.isVerified,
        })),
    }))
    .filter((rr) => rr.answers.length > 0);
